import { Cents, Money, toCentsFromString, toMoney } from '@betterment/core';

export function parseFloatFromNumberInputMask(input: string): number {
  // Remove commas from the input string
  const sanitizedInput = input.replace(/,/g, '');

  // Parse the sanitized string into a float
  const result = parseFloat(sanitizedInput);

  // Return the parsed float or NaN
  return result;
}

export function parseMoneyFromNumberInputMask(input: string): Money | null {
  const cents = parseCentsFromNumberInputMask(input);

  if (Number.isNaN(cents)) {
    return null;
  }

  return toMoney(cents);
}

export function parseCentsFromNumberInputMask(input: string): Cents {
  // Remove commas from the input string
  const sanitizedInput = input.replace(/,/g, '');

  return toCentsFromString(sanitizedInput);
}
